import React from 'react';

import styles from './Footer.css';

const Footer = props => {
  const { itemDetail, onCancel, handleSubmit, handleDelete } = props;
  return (
    <div className={styles['container-hyperlink']}>
      <div className="footer-form-item">
        {itemDetail && (
          <span className="pull-left">
            <button
              className="btn btn-danger no-outline"
              onClick={handleDelete}
            >
              <i className="fa fa-trash" />
            </button>
          </span>
        )}
        <span className="pull-right">
          <button
            className={`btn btn-default no-outline ${
              styles['margin-right-10']
            }`}
            type="button"
            onClick={onCancel}
          >
            Cancel
          </button>
          <button
            className="btn btn-primary no-outline"
            type="button"
            onClick={handleSubmit}
          >
            Save
          </button>
        </span>
      </div>
    </div>
  );
};

export default Footer;
